const language = {
    VIETNAM: 'vi',
    ENGLISH: 'en',
};

export default language;
